__turbopack_context__.v({
  "card": "AboutPerfectFit-module__cr0zNW__card",
  "cards": "AboutPerfectFit-module__cr0zNW__cards",
  "caret": "AboutPerfectFit-module__cr0zNW__caret",
  "content": "AboutPerfectFit-module__cr0zNW__content",
  "desc": "AboutPerfectFit-module__cr0zNW__desc",
  "disclaimer": "AboutPerfectFit-module__cr0zNW__disclaimer",
  "disclaimerTitle": "AboutPerfectFit-module__cr0zNW__disclaimerTitle",
  "imgDesktop": "AboutPerfectFit-module__cr0zNW__imgDesktop",
  "imgMobile": "AboutPerfectFit-module__cr0zNW__imgMobile",
  "root": "AboutPerfectFit-module__cr0zNW__root",
  "textContent": "AboutPerfectFit-module__cr0zNW__textContent",
});
